import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import { publicApi } from "@/api";

export const Footer = ({ variant = "wizard" }) => {
  const [contacto, setContacto] = useState({ whatsapp: "", empresa: "Seguros Para Moto" });
  const [abierto, setAbierto] = useState(false);
  const [nombre, setNombre] = useState("");
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    publicApi.get("/public/params/contacto").then((r) => setContacto(r.data)).catch(() => {});
  }, []);

  const waHref = () => {
    const texto = `Hola! Soy ${nombre || "un interesado"}. ${mensaje || "Quiero hacer una consulta sobre el seguro de mi moto."}`;
    const num = (contacto.whatsapp || "").replace(/\D/g, "");
    return `https://wa.me/${num}?text=${encodeURIComponent(texto)}`;
  };

  return (
    <footer data-testid="site-footer" className={`w-full border-t border-slate-200 bg-slate-50 ${variant === "wizard" ? "mt-8" : ""}`}>
      <div className="max-w-3xl mx-auto px-4 py-8 text-xs text-slate-500 leading-relaxed space-y-4 sm:text-center">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          <Link to="/terminos" data-testid="footer-terminos" className="font-semibold text-slate-700 hover:text-emerald-700 underline underline-offset-2">Términos y Condiciones</Link>
          <Link to="/privacidad" data-testid="footer-privacidad" className="font-semibold text-slate-700 hover:text-emerald-700 underline underline-offset-2">Política de Privacidad</Link>
          <button type="button" data-testid="footer-contacto-btn" onClick={() => setAbierto(true)}
            className="font-semibold text-slate-700 hover:text-emerald-700 underline underline-offset-2">
            Contacto
          </button>
        </div>

        <p data-testid="footer-aseguradora">Las pólizas son emitidas por <b>ATM Compañía de Seguros SA</b>.</p>
        <p data-testid="footer-productor">Claudio Luis Acosta · Productor Asesor de Seguros · SSN: 89459</p>
      </div>

      {abierto && (
        <div className="fixed inset-0 z-[70] bg-black/50 flex items-end sm:items-center justify-center" onClick={() => setAbierto(false)} data-testid="contacto-modal">
          <div className="bg-white rounded-t-[28px] sm:rounded-[24px] w-full max-w-md p-6 shadow-[0_24px_60px_rgba(0,0,0,0.25)]" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-3">
              <h3 className="font-heading font-bold text-lg text-slate-900">Contactanos</h3>
              <button data-testid="contacto-modal-close" onClick={() => setAbierto(false)} className="p-1 -m-1 text-slate-400"><X className="w-6 h-6" /></button>
            </div>
            <p className="text-sm text-slate-500 mb-4">Escribinos tu consulta y te respondemos por WhatsApp.</p>
            <input data-testid="contacto-nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Tu nombre"
              className="w-full h-12 px-4 mb-3 bg-white border border-slate-300 rounded-xl text-base focus:border-emerald-600 outline-none" />
            <textarea data-testid="contacto-mensaje" value={mensaje} onChange={(e) => setMensaje(e.target.value)} placeholder="Tu mensaje o consulta" rows={4}
              className="w-full px-4 py-3 mb-4 bg-white border border-slate-300 rounded-xl text-base focus:border-emerald-600 outline-none resize-none" />
            <a data-testid="contacto-enviar-whatsapp" href={waHref()} target="_blank" rel="noopener noreferrer" onClick={() => setAbierto(false)}
              className="w-full h-14 rounded-full bg-[#25D366] text-white font-heading font-semibold text-lg flex items-center justify-center gap-2">
              <MessageCircle className="w-5 h-5" /> Enviar por WhatsApp
            </a>
          </div>
        </div>
      )}
    </footer>
  );
};
